module.exports = __webpack_public_path__ + "static/fg-45e175c953983ec70f2d054555c8bda1.png";